const {langCode} = GLOBAL;

export default () => ({
    letterIndex: 0,
    letterSelected: '',
    loading: false,
    maxPages: 0,
    query: {
        lang: langCode,
        letter: '',
        page: 1,
        ppp: 10,
        search: '',
    },
    results: [],
    searchTerm: '',
    total: 0,
})
